/* ======================================================================
   THE WICKLOW WITCH — CUSTOM THEME JAVASCRIPT
   ----------------------------------------------------------------------
   Only applies the first-word colour treatment to Dawn Rich Text
   headings. Other headings are deliberately left untouched.
   ====================================================================== */

(function () {
  'use strict';

  var selector = '.rich-text__heading';

  function wrapFirstWord(heading) {
    if (!heading || heading.querySelector('.first-word')) {
      return;
    }

    var textNode = null;

    for (var i = 0; i < heading.childNodes.length; i++) {
      if (
        heading.childNodes[i].nodeType === Node.TEXT_NODE &&
        heading.childNodes[i].textContent.trim()
      ) {
        textNode = heading.childNodes[i];
        break;
      }
    }

    if (!textNode) {
      return;
    }

    var text = textNode.textContent;
    var match = text.match(/^(\s*)(\S+)([\s\S]*)$/);

    if (!match) {
      return;
    }

    var fragment = document.createDocumentFragment();

    if (match[1]) {
      fragment.appendChild(
        document.createTextNode(match[1])
      );
    }

    var span = document.createElement('span');
    span.className = 'first-word';
    span.textContent = match[2];

    fragment.appendChild(span);

    if (match[3]) {
      fragment.appendChild(
        document.createTextNode(match[3])
      );
    }

    textNode.parentNode.replaceChild(fragment, textNode);
  }

  function processHeadings(root) {
    if (!root) {
      return;
    }

    if (
      root.nodeType === Node.ELEMENT_NODE &&
      root.matches &&
      root.matches(selector)
    ) {
      wrapFirstWord(root);
    }

    var headings = root.querySelectorAll
      ? root.querySelectorAll(selector)
      : [];

    for (var i = 0; i < headings.length; i++) {
      wrapFirstWord(headings[i]);
    }
  }

  function init() {
    processHeadings(document);

    /*
     * Shopify Theme Editor can re-render sections without
     * reloading the whole page, so handle newly-added content.
     */
    if (typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var nodes = mutations[i].addedNodes;

          for (var j = 0; j < nodes.length; j++) {
            if (nodes[j].nodeType === Node.ELEMENT_NODE) {
              processHeadings(nodes[j]);
            }
          }
        }
      });

      if (document.body) {
        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }
})();